import {useState} from "react";
import {connect} from "react-redux";

import {
  MFAContainer,
} from "../../../styled";
import {isValidEmail} from "../../../../utils/utils";
import {CustomDivider, CustomGrid} from "../../../../components/custom-common";
import {Form, Header} from "semantic-ui-react";


const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    user: state.auth.userName,
  }
}

const EmailConfig = ({ toggleFooterActionDisabled, setEmailSetUpToMFA }) => {
  const [email, setEmail] = useState('')
  const [isInvalidEmail, setIsInvalidEmail] = useState(false)

  const handleChange = (e) => {
    const { value } = e.target
    setEmail(value)
    setEmailSetUpToMFA(value)
    validateEmail(e)
  }

  const validateEmail = (e) => {
    const { value } = e.target
    const isValid = isValidEmail(value)
    setIsInvalidEmail(!isValid)
    toggleFooterActionDisabled(!isValid)
  }

  return (
    <>
      <MFAContainer className="sectionWrapper" maxWidth={"633px"}>
        <CustomGrid>
          <CustomGrid.Row>
            <CustomGrid.Column>
              <Header as="h2" className={'noVerticalMargin'}>Configure two-factor authentication</Header>
              <CustomDivider smaller hidden/>
              <p className={'neutral700Text'}>
                Please provide the email address that we will utilize for two-factor authentication below—
              </p>
            </CustomGrid.Column>
          </CustomGrid.Row>
          <CustomGrid.Row>
            <CustomGrid.Column>
              <Form>
                <Form.Field className={'mfaVerifyCode'}>
                  <Form.Input
                    label={"Email address"}
                    type='email'
                    name='email'
                    large={300}
                    value={email}
                    onChange={handleChange}
                    onBlur={validateEmail}
                    error={isInvalidEmail}
                    required
                    className={'noVerticalMargin'}
                  />
                  {isInvalidEmail && (
                      <p className={'warningRedText smaller'}>
                        Invalid email format
                      </p>
                  )}
                </Form.Field>
              </Form>
            </CustomGrid.Column>
          </CustomGrid.Row>
        </CustomGrid>
      </MFAContainer>
    </>
  )
}

export default connect(mapStateToProps)(EmailConfig);
